const React = require("react");
const withReDelay = require("mn-utils/withReDelay");
const RefreshIcon = require("@material-ui/icons/Refresh").default;
const AddIcon = require("@material-ui/icons/Add").default;
const {initFilter, getFilterParams, IntervalFilterAdmin} = require("../../../../../dumb/IntervalFilterCustom");
const virtualOutputComponentProvider = require("../../../../../../utils/virtualOutputComponentProvider");
const {apiAdminCustomerRefundList} = require("../../../../../../api/admin/refunds");
const LayoutA = require("../../../../../dumb/Layout/A");
const HeaderA = require("../../../../../dumb/Header/A");
const CaptionA = require("../../../../../dumb/Caption/A");
const WrapperWithLoading = require("../../../../../dumb/WrapperWithLoading");
const ButtonD = require("../../../../../dumb/Button/D");
const RowB = require("../../../../../dumb/Row/B");
const ColB = require("../../../../../dumb/Col/B");
const ColB2 = require("../../../../../dumb/Col/B2");
const ButtonUp = require("../../../../../dumb/Button/Up");
const {statusesFilter} = require("../../constants/statuses");
const TableItem = require("./components/TableItem");
const openNewCustomerRefundPopup = require("./utils/openNewCustomerRefundPopup");

const filter$ = initFilter();

module.exports = virtualOutputComponentProvider({
  state: {
    filter: filter$,
  },
  rowHeight: 70,
  nodata: (<div className="f16 fw4 cF mt20 ttU tc w">No data</div>),
  request: apiAdminCustomerRefundList,
  getParams: getFilterParams('status'),
  wrapper(render, setState, self) {
    const {
      handleSortProvider,
    } = self;

    const handleSortByOrderIdToggle = handleSortProvider('order_id');
    const handleSortByStatusToggle = handleSortProvider('status');

    const dateTo = new Date();
    const dateFrom = new Date();
    dateFrom.setDate(dateTo.getDate() - 30);
    self.state = {
      ...(self.state || {}),
      dateTo,
      dateFrom,
    };

    function handleChangeFilter(filter) {
      const update = withReDelay(self.update, 1000);
      filter$.emit({
        ...self.state.filter,
        ...filter,
      });
      update();
    }

    return (state) => {
      const filter = state.filter;

      const params = state.params || {};
      const sort = params.sort;
      const loading = state.loading || false;
      const showUp = state.showUp || false;


      return (
        <>
          <div className="h75 layoutRow jcFE aiC">
            <ButtonD
              className="wmin100"
              onClick={() => openNewCustomerRefundPopup(self.update)}
            >
              <AddIcon/>
              <div className="pl15">Add new refund</div>
            </ButtonD>
            <WrapperWithLoading
              loading={loading}
            >
              <ButtonD
                className="wmin100"
                onClick={self.update}
              >
                <RefreshIcon/>
                <div className="pl15">Refresh</div>
              </ButtonD>
            </WrapperWithLoading>
          </div>
          <div className="layoutRow jcSB">
            <IntervalFilterAdmin
              className="mt32"
              data={filter}
              search={{
                className: 'w330',
                placeholder: 'Search by ID / Hash / Email / Amount'
              }}
              onChange={handleChangeFilter}
              // selectFilters={[statusesFilter]}
              // hideSearch
            />
          {/*  <div className="layoutRow fhaS fvaC">*/}
          {/*    <WrapperWithLoading*/}
          {/*      loading={loading}*/}
          {/*    >*/}
          {/*      <ButtonD*/}
          {/*        className="wmin100"*/}
          {/*        onClick={self.update}*/}
          {/*      >*/}
          {/*        <RefreshIcon/>*/}
          {/*        <div className="pl15">Refresh</div>*/}
          {/*      </ButtonD>*/}
          {/*    </WrapperWithLoading>*/}
          {/*  </div>*/}
          </div>
          <div className="rlv h100vh-380 mh-45">
            <div className="ovxA abs s ph45">
              <div className="wmin1380 rlv h">
                <div>
                  <RowB className="f14">
                    <ColB className="wmin155 fx1">
                      ID
                    </ColB>
                    <ColB className="wmin180 fx1">
                      Hash
                    </ColB>
                    <ColB className="wmin150 fx1">
                      Buyer Email
                    </ColB>
                    <ColB className="wmin95">
                      Created
                    </ColB>
                    <ColB className="wmin95">
                      Resolved
                    </ColB>
                    {/*<ColB className="wmin150 fx1">*/}
                    {/*  Fiat Amount*/}
                    {/*</ColB>*/}
                    <ColB className="wmin150 fx1">
                      CC Amount
                    </ColB>
                    <ColB className="wmin155 fx1">
                      Auction ID
                    </ColB>
                    <ColB className="wmin150 fx1">
                      Status
                    </ColB>
                    <ColB2 className="w56"/>
                    {/*<ColB2 className="w56"/>*/}
                    <ColB2 className="w56"/>
                    <ColB2 className="w56"/>
                  </RowB>
                </div>
                <div className="abs st70 sh-45 sb10 ovH">
                  {render(TableItem)}
                </div>
              </div>
            </div>
            <ButtonUp
              show={showUp}
              onClick={self.handleToUp}
            />
          </div>
        </>
      );
    };
  },
});
